/* import __COLOCATED_TEMPLATE__ from './sh-btn.hbs'; */
import Component from '@ember/component';
import { computed } from '@ember/object';
import { oneWay, equal } from '@ember/object/computed';

export default Component.extend({
  tagName: 'a',
  classNameBindings: ['disabled', 'buttonClass', 'active:active'],
  attributeBindings: ['disabled', 'href', 'customTarget:target', 'tabindex'],
  text: null,
  iconString: null,
  customTarget: undefined,
  iconPosition: oneWay('_mdSettings.buttonIconPosition'),
  buttonType: null,
  isFlat: equal('buttonType', 'flat'),
  isDisabled: false,
  isIcon: equal('buttonType', 'iconString'),

  buttonClass: computed('buttonType', function() {
    const buttonType = this.get('buttonType');
    return buttonType ? `btn-${buttonType}` : 'btn';
  }),

  click() {
    this._processAction();
  },

  _processAction() {
    if (!this.disabled) {
      this.action?.();
    }
  },
});

